function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "prefix__Group_327",
  "data-name": "Group 327",
  transform: "translate(6.875 5.312)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16.015,
    height: 16,
    viewBox: "0 0 16.015 16"
  }, props), React.createElement("g", {
    id: "prefix__Expanded",
    transform: "translate(.5 .5)"
  }, React.createElement("g", {
    id: "prefix__Group_330",
    "data-name": "Group 330"
  }, React.createElement("g", {
    id: "prefix__Group_326",
    "data-name": "Group 326",
    transform: "translate(0 1.25)"
  }, React.createElement("path", {
    id: "prefix__Path_310",
    d: "M11.562 17.75H0V4h9.062a.312.312 0 1 1 0 .625H.625v12.5h10.312V10.25a.312.312 0 1 1 .625 0z",
    className: "prefix__cls-1",
    "data-name": "Path 310",
    transform: "translate(0 -4)",
    style: {
      "fill": "#fff",
      "stroke": "#fff"
    }
  })), _ref, React.createElement("g", {
    id: "prefix__Group_328",
    "data-name": "Group 328",
    transform: "translate(6.449)"
  }, React.createElement("path", {
    id: "prefix__Path_312",
    d: "M20.949 8.551a.313.313 0 0 1-.28-.452l.884-1.768a.306.306 0 0 1 .059-.081L27.578.283A.912.912 0 0 1 28.23 0a.979.979 0 0 1 .887.609.9.9 0 0 1-.213 1l-5.967 5.966a.321.321 0 0 1-.081.059l-1.768.884a.312.312 0 0 1-.139.033zm1.141-1.9l-.442.884.884-.442 5.93-5.93a.275.275 0 0 0 .078-.315.363.363 0 0 0-.31-.223.3.3 0 0 0-.211.1z",
    className: "prefix__cls-1",
    "data-name": "Path 312",
    transform: "translate(-20.636)",
    style: {
      "fill": "#fff",
      "stroke": "#fff"
    }
  })), React.createElement("g", {
    id: "prefix__Group_329",
    "data-name": "Group 329",
    transform: "translate(12.415 1.075)"
  }, React.createElement("path", {
    id: "prefix__Path_313",
    d: "M40.925 4.951a.313.313 0 0 1-.221-.092l-.884-.884a.313.313 0 0 1 .442-.442l.884.884a.313.313 0 0 1-.221.534z",
    className: "prefix__cls-1",
    "data-name": "Path 313",
    transform: "translate(-39.728 -3.441)",
    style: {
      "fill": "#fff",
      "stroke": "#fff"
    }
  })))));
};

export default __webpack_public_path__ + "static/media/job_add_info.528cde5b.svg";
export { SvgComponent as ReactComponent };